import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Typography from "../components/v2/Typography";
import { ChevronUp, FileText, Download } from "lucide-react";
import ContactSection from "../atoms/Contact";
import Footer from "../atoms/Footer";
import Button from "../components/v2/Button";

const TransferAgreementPage = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDownload = () => {
        // Link to the actual PDF file
        window.open('/docs/transfer agreement.pdf', '_blank');
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <div className="agreement-page">
                <div className="agreement-container">
                    {/* <div className="agreement-header">
                        <div className="agreement-logo">
                            <img src="/logo.png" alt="NameConnect" style={{ height: '50px', marginBottom: '20px' }} />
                        </div>
                        <Typography variant="h1">Domain Name Sale and Ownership Transfer Agreement</Typography>
                        <p className="agreement-subtitle">NameConnect</p>
                        <div className="agreement-actions">
                            <Button variant="secondary" onClick={handleDownload}>
                                <Download size={18} />
                                <span>Download PDF</span>
                            </Button>
                            <Button variant="secondary" onClick={handlePrint}>
                                <FileText size={18} />
                                <span>Print Agreement</span>
                            </Button>
                        </div>
                    </div> */}

                    <div className="agreement-header">
                        <Typography variant="h1">Domain Name Sale and Ownership Transfer Agreement</Typography>
                        <p className="agreement-subtitle">By NameConnect</p>
                    </div>

                    <div className="agreement-content">
                        <div className="agreement-intro">
                            <p>This Domain Name Sale and Ownership Transfer Agreement is entered into on 
                            this <span className="fill-field">[effective date]</span> between <span className="fill-field">[Seller's name]</span> of <span className="fill-field">[Seller's company 
                            name, if applicable]</span> located at <span className="fill-field">[Seller's full address]</span> 
                            ("Seller"), and <span className="fill-field">[Purchaser's name]</span> of <span className="fill-field">[Purchaser's company name, if 
                            applicable]</span> located at <span className="fill-field">[Purchaser's full address]</span> 
                            ("Purchaser"), with NameConnect, a brokerage company, 
                            facilitating this agreement. This agreement sets forth all terms and conditions under which 
                            Seller agrees to sell and transfer to Purchaser all ownership rights in and to the domain 
                            name <span className="fill-field">[domain name]</span> ("Domain Name") including any and all trademark rights and 
                            attendant goodwill associated therewith.</p>
                            
                            <p style={{ marginTop: '20px', fontWeight: '600' }}>Seller and the Purchaser hereby agree as follows:</p>
                        </div>

                        <div className="agreement-section">
                            <h2>1. Purchase Price.</h2>
                            <p>In consideration for payment of <span className="fill-field">[purchase price, written-out]</span> 
                            dollars (<span className="fill-field">$[purchase price, numerical].00</span>), 
                            the sufficiency of which is hereby acknowledged ("Purchase Price"), paid 
                            by Purchaser to Seller, Seller hereby assigns, sells, transfers, and conveys to Purchaser all 
                            of Seller's right, title, and interest in and to the Domain Name. Payment will be made in 
                            US dollars.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>2. Seller's Representations.</h2>
                            <p>Seller represents and warrants that it is the lawful and 
                            exclusive registrant of the Domain Name and no other party has any right to registration 
                            of the Domain Name or has otherwise made any claim to the Domain Name. Seller 
                            further represents and warrants that it has the exclusive authority to enter into this 
                            transaction and transfer the Domain Name, free of the claims of any third parties.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>3. Transfer of the Domain Name.</h2>
                            <p>The Domain Name is registered with <span className="fill-field">[Registrar's name]</span>, 
                            an ICANN accredited registrar system. Upon confirmation of receipt of 
                            Purchase Price, Seller shall provide Purchaser with a password or Seller shall push the 
                            Domain Name to Purchaser's account at Registrar within 2 days of receiving payment. 
                            This enables Purchaser to modify the registration information as desired, transfer the 
                            Domain Name to a different Registrar, and/or to change Purchaser's password/username 
                            to take full control of the Domain Name.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>4. Further Assurances.</h2>
                            <p>Seller shall take all necessary actions, including providing all 
                            necessary documentation to Purchaser in order to transfer Domain Name to Purchaser.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>5. Counterparts/Fax.</h2>
                            <p>This Agreement may be signed in counterparts. Signed counterparts 
                            of this Agreement transmitted via Fax are equivalent to a signed original of this 
                            Agreement.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>6. Governing Law.</h2>
                            <p>This Agreement is made under and shall be governed by and interpreted 
                            in accordance with the laws of the State of Florida, without regard to that state's choice of 
                            law principles, which may direct the application of the laws of another jurisdiction. The 
                            parties agree that any legal action or proceeding relating to this Agreement shall be 
                            brought exclusively in the state or federal courts located within the State of Florida.</p>
                        </div>

                        <div className="agreement-section">
                            <h2>7. Entire Agreement.</h2>
                            <p>This Agreement constitutes and contains the entire agreement 
                            between the parties with respect to the subject matter herein and supersedes any prior oral 
                            or written agreements. This Agreement cannot be changed, modified, amended, or 
                            supplemented, except in writing signed by all parties hereto.</p>
                        </div>

                    </div>
                </div>

                <button 
                    className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    <ChevronUp size={24} />
                </button>
            </div>

            <ContactSection />
        </>
    );
};

export default TransferAgreementPage;